import { ITypedReduxAction } from '../../../common/types/redux/actionType';

export enum EGeoFocusActionType {
  SetAwaitingGeoFocus = 'geoFocus/setAwaiting',
}

export type TSetAwaitingGeoFocus = ITypedReduxAction<EGeoFocusActionType.SetAwaitingGeoFocus, boolean>;

export type TGeoFocusActions = TSetAwaitingGeoFocus;
